import 'reflect-metadata';
import 'rxjs';

import '@angular/common';
import '@angular/compiler';
import '@angular/core';
import '@angular/forms';
import '@angular/http';
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/router';

import 'primeng/primeng';
import 'primeng/resources/primeng.min.css';


import 'bootstrap/dist/css/bootstrap.css';
import 'primeui/themes/omega/theme.css';
import 'primeui/primeui-ng-all.min.css';
import 'lodash';


require('../font-awesome-4.6.3/font-awesome-4.6.3/css/font-awesome.min.css');
require('chart.js/src/chart.js');




/** WEBPACK FOOTER **
 ** ./app/vendor.ts
 **/